import { Toaster } from "sonner";

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="flex grow flex-col">
      <main className="flex grow flex-col">
        <div className="flex grow flex-col">
          {children}
        </div>
      </main>
      <Toaster position="top-center" richColors />
    </div>
  );
}

